import { type ComponentProps, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const actionSheetLabel = tailwindVariants({
  base: 'font-bold ads:text-metadata text-12 text-gray-10 uppercase tracking-wide',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'px-2',
      small: 'px-1.5',
    },
  },
});

export type ActionSheetLabelVariants = VariantProps<typeof actionSheetLabel>;

export type ActionSheetLabelProps = Omit<ComponentProps<'div'>, 'size'> & ActionSheetLabelVariants;

export const ActionSheetLabel = memo(({ className, size = 'small', ...restOfProps }: ActionSheetLabelProps) => {
  return <div className={actionSheetLabel({ className, size })} data-testid="ACTION_SHEET_LABEL" {...restOfProps} />;
});

ActionSheetLabel.displayName = 'DropdownMenuLabel';
